package com.essntl.uikit.components.toggle

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsTab(
    selectedItemIndex: Int,
    items: List<TabState>,
    modifier: Modifier = Modifier,
    tabWidth: Dp = 100.dp,
    onClick: (tabState: TabState) -> Unit,
) {
    val indicatorOffset: Dp by animateDpAsState(
        targetValue = tabWidth * selectedItemIndex,
        animationSpec = tween(
            durationMillis = 150,
            easing = LinearEasing,
        ),
    )

    Box(
        modifier = modifier
            .clip(CircleShape)
            .background(MaterialTheme.esColorScheme.bgPrimary)
            .height(intrinsicSize = IntrinsicSize.Min),
    ) {
        EsTabIndicator(
            indicatorWidth = tabWidth,
            indicatorOffset = indicatorOffset,
            indicatorColor = MaterialTheme.esColorScheme.primary,
        )
        Row(
            horizontalArrangement = Arrangement.Center,
            modifier = Modifier.clip(CircleShape),
        ) {
            items.mapIndexed { index, tabState ->
                val isSelected = index == selectedItemIndex
                EsTabItem(
                    isSelected = isSelected,
                    onClick = {
                        if (!isSelected)
                            onClick(tabState)
                    },
                    tabWidth = tabWidth,
                    tabState = tabState,
                )
            }
        }
    }
}
